const {getReleaseList} = require('../../services/ReleaseService');

export default {
  namespaced: true,
  state: {
    releaseList: [],
    release: null,
    releaseToEdit: null
  },
  getters: {
    clientId: (state) => {
      return state.user && state.user.clientId ? state.user.clientId : null;
    },
    currentUser: (state) => {
      return state.user;
    },
    isValidToken: (state) => {
      return state.isValidToken;
    },
    getToken: (state) => {
      return state.token;
    },
    releaseList: (state) => {
      return state.releaseList;
    },
    releaseToEdit: (state) => {
      return state.releaseToEdit;
    },
    initialRelease: (state) => {
      return state.initialRelease;
    },
    releaseEdited: (state) => {
      if (state.releaseToEdit) {
        for (let key of Object.keys(state.releaseToEdit)) {
          if (key === 'email' || key === 'directPhone' || key === 'officePhone') {
            let editValue = state.releaseToEdit[key] ? String(state.releaseToEdit[key]).toLowerCase() : '';
            let initialValue = state.initialrelease[key] ? String(state.initialrelease[key]).toLowerCase() : '';
            if (editValue !== initialValue) {
              return true;
            }
          }
        }
      }
      return false;
    }
  },
  mutations: {
    updateUserClient (state, user) {
      state.user = user;
    },
    setIsValidToken (state, isValid) {
      state.isValidToken = isValid;
    },
    setToken (state, token) {
      state.token = token;
    },
    setReleaseList (state, releaseList) {
      state.releaseList = releaseList;
    },
    setReleaseToEdit (state, release) {
      state.releaseToEdit = Object.assign({}, release);
      state.initialrelease = Object.assign({}, release);
    },
    setReleaseToEditVersion (state, release) {
      state.releaseToEdit = Object.assign({}, release);
      state.initialrelease = Object.assign({}, release);
    }
  },
  actions: {
    async loadReleaseList ({commit}, clientId = null) {
      try {
        let ReleaseList = null;
        if (clientId) {
          const releasedata = await getReleaseList(clientId);
          ReleaseList = releasedata.data;
        }
        commit('setReleaseList', ReleaseList);
      } catch (error) {
        console.log(error);
        throw error;
      }
    },
    clearReleaseList ({commit}) {
      commit('setReleaseList', null);
    },
    setReleaseToEdit ({commit}, release) {
      commit('setReleaseToEdit', release);
    },
    clearReleaseToEdit ({commit}) {
      commit('setReleaseToEdit', null);
    },
    setReleaseToEditVersion ({commit}, release) {
      commit('setReleaseToEditVersion', release);
    },
    clearReleaseToEditVersion ({commit}) {
      commit('setReleaseToEditVersion', null);
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/releaseModule.js